module.exports = __webpack_public_path__ + "static/media/disco.d59fd3a7.mp4";